import i18n from "i18next";
import en from "../constant/lang/en.json";
import de from "../constant/lang/de.json";
import { initReactI18next } from "react-i18next";

const resources = {
  en: {
    translation: en,
  },
  de: {
    translation: de,
  },
};

i18n.use(initReactI18next).init({
  resources,
  fallbackLng: "en",
  debug: true,
  interpolation: {
    escapeValue: false,
  },
});

export default i18n;
